export enum TagVariant {
  FILLED = 'filled',
  OUTLINED = 'outlined',
  NONE = 'none'
}

export enum TagColorMode {
  COLORFUL = 'colorful',
  UNIFORM = 'uniform'
}

export enum CourseTagType {
  TRAINER = 'trainer',
  PARTICIPANT = 'participant',
  COORDINATOR = 'coordinator',
  DEMO = 'demo',
  IN_SESSION = 'in session',
  PLANNED = 'planned',
  ENDED = 'ended',
  FINISHED = 'finished'
}

export enum TagColor {
  LIGHT_GREEN = '#8BA90F',
  DARK_GREEN = '#3D9E41',
  LIGHT_BLUE = '#0EABE6',
  DARK_BLUE = '#3D7ED1',
  YELLOW = '#E6DC3C',
  ORANGE = '#D17D47',
  RED = '#E6244F',
  BROWN = '#947065',
  PINK = '#ED6BC8',
  VIOLET = '#6A1B9A',
  DARK_GREY = '#424242',
  TEAL = '#3D9A9E'
}

export const DEFAULT_TAG_VARIANT = TagVariant.OUTLINED;
export const DEFAULT_TAG_COLOR_MODE = TagColorMode.UNIFORM;
export const DEFAULT_UNIFORM_COLOR = '#ffffff';
export const DEFAULT_BORDER_SIZE = 2;
export const DEFAULT_FONT_SIZE = 11;
export const DEFAULT_BORDER_RADIUS = 12;
export const DEFAULT_LETTER_SPACING = 0.4;
export const DEFAULT_PADDING = '2px 8px';

export const TAG_COLORS = [
  TagColor.LIGHT_GREEN,
  TagColor.DARK_GREEN,
  TagColor.LIGHT_BLUE,
  TagColor.DARK_BLUE,
  TagColor.YELLOW,
  TagColor.ORANGE,
  TagColor.RED,
  TagColor.BROWN,
  TagColor.PINK,
  TagColor.VIOLET,
  TagColor.DARK_GREY,
  TagColor.TEAL
] as const;

export const PREDEFINED_TAG_COLORS: Record<string, TagColor> = {
  [CourseTagType.TRAINER]: TagColor.LIGHT_GREEN,
  [CourseTagType.PARTICIPANT]: TagColor.DARK_GREEN,
  [CourseTagType.COORDINATOR]: TagColor.LIGHT_BLUE,
  [CourseTagType.DEMO]: TagColor.DARK_BLUE,
  Demo: TagColor.DARK_BLUE,
  [CourseTagType.IN_SESSION]: TagColor.YELLOW,
  'In Session': TagColor.YELLOW,
  [CourseTagType.PLANNED]: TagColor.ORANGE,
  Planned: TagColor.ORANGE,
  [CourseTagType.ENDED]: TagColor.RED,
  Ended: TagColor.RED,
  [CourseTagType.FINISHED]: TagColor.BROWN,
  Finished: TagColor.BROWN
};
